<!-- SIDENAV HEADER -->
<div class="sidenav-header">
  <!-- CHATS TOOLBAR -->
  <mat-toolbar>
    <!-- TOOLBAR TOP -->
    <mat-toolbar-row class="flex-row-space-between-center">
      <div class="contact-name">{{ 'CHAT.CHATS' | translate }}</div>

      <button
        mat-icon-button
        (click)="newConversation()"
        [attr.aria-label]="'CHAT.NEW_CONVERSATION' | translate"
        [matTooltip]="'CHAT.NEW_CONVERSATION' | translate"
      >
        <mat-icon>add_comment</mat-icon>
      </button>
    </mat-toolbar-row>
    <!-- / TOOLBAR TOP -->

    <!-- TOOLBAR BOTTOM -->
    <mat-toolbar-row>
      <!-- SEARCH -->
      <div class="search-wrapper flex-row-start-center fxFlex">
        <div class="search flex-row-start-center fxFlex">
          <mat-icon class="s-16 secondary-text">search</mat-icon>
          <input
            [ngModel]="searchText()"
            (ngModelChange)="searchText.set($event); onSearchChanged()"
            type="text"
            [placeholder]="'CHAT.SEARCH' | translate"
            class="fxFlex"
          />
          <button *ngIf="searchText() !== ''" mat-icon-button class="s-16" (click)="clearSearch()" aria-label="clear search">
            <mat-icon class="s-16 secondary-text">close</mat-icon>
          </button>
        </div>
      </div>
      <!-- / SEARCH -->
    </mat-toolbar-row>

    <!-- SCOPE : dans cette conversation (visible quand un fil est actif) -->
    <mat-toolbar-row *ngIf="searchText().trim().length >= 3 && store.activeConversationId()" class="chat-search-scope">
      <label class="flex-row-start-center">
        <input type="checkbox" [checked]="searchInActiveOnly()" (change)="toggleSearchScope()" class="mr-8" />
        {{ 'CHAT.IN_THIS_CONVERSATION' | translate }}
      </label>
    </mat-toolbar-row>
    <!-- / TOOLBAR BOTTOM -->
  </mat-toolbar>
  <!-- / CHATS TOOLBAR -->
</div>
<!-- / SIDENAV HEADER -->

<!-- SIDENAV CONTENT -->
<div class="sidenav-content fxFlex" fusePerfectScrollbar>
  <!-- RÉSULTATS DE RECHERCHE MESSAGES (T7) -->
  <div *ngIf="searchResults() !== null" class="chat-search-results">
    <div class="chat-search-results-title secondary-text">
      {{ 'CHAT.SEARCH_RESULTS' | translate }}
      <span *ngIf="searching()">…</span>
    </div>

    <div *ngFor="let group of searchResults()" class="chat-search-group">
      <div class="chat-search-group-name">{{ group.conversation?.display_name || group.conversation?.name }}</div>
      <button
        *ngFor="let message of group.messages"
        type="button"
        class="chat-search-result"
        (click)="openSearchResult(group, message)"
      >
        <span class="chat-search-result-meta">
          <strong>{{ message.sender?.name }}</strong>
          <span class="secondary-text">{{ message.created_at | date: 'short' }}</span>
        </span>
        <span class="chat-search-result-body" [innerHTML]="highlightExcerpt(message)"></span>
      </button>
    </div>

    <div *ngIf="!searching() && searchResults()!.length === 0" class="no-results-message">
      {{ 'CHAT.NO_RESULTS' | translate }}
    </div>
  </div>

  <!-- CHATS CONTENT -->
  <div *ngIf="searchResults() === null">
    <!-- CHATS LIST-->
    <div class="chat-list flex-column">
      <button
        mat-button
        class="contact"
        *ngFor="let conversation of filteredConversations()"
        (click)="openConversation(conversation)"
        [ngClass]="{
          unread: (conversation.unread_count ?? 0) > 0,
          active: store.activeConversationId() === conversation.uuid,
        }"
      >
        <div class="flex-row-start-center">
          <div class="avatar-wrapper flex-column-center-center fxFlexNoAuto">
            <img
              *ngIf="avatar(conversation); else initialsAvatar"
              class="avatar"
              [src]="avatar(conversation)"
              [alt]="displayName(conversation)"
              onerror="
                if (this.src !== '/assets/images/avatars/default-no-avatar.png')
                  this.src = '/assets/images/avatars/default-no-avatar.png';
              "
            />
            <ng-template #initialsAvatar>
              <div class="avatar chat-initials-avatar accent">
                {{ initials(conversation) }}
              </div>
            </ng-template>
            <span *ngIf="store.isDirectPeerOnline(conversation)" class="chat-online-dot on-avatar"></span>
          </div>

          <div class="flex-row fxFlex">
            <div class="pr-4 flex-column-start-start fxFlex">
              <div class="contact-name flex-row-start-center">
                <mat-icon *ngIf="conversation.is_muted" class="s-14 secondary-text mr-4">notifications_off</mat-icon>
                <mat-icon *ngIf="conversation.is_locked" class="s-14 secondary-text mr-4">lock</mat-icon>
                {{ displayName(conversation) }}
              </div>
              <div class="contact-last-message">{{ excerpt(conversation) }}</div>
            </div>

            <div class="flex-column-start-end">
              <div class="contact-last-message-time">
                {{ conversation.last_message_at | date: 'shortTime' }}
              </div>
              <div class="flex-row-start-center">
                <!-- badge @ : mention non lue — visible MÊME muté (perce le mute, T7) -->
                <span
                  *ngIf="(conversation.unread_mentions_count ?? 0) > 0"
                  class="mt-4 mr-4 chat-mention-badge"
                  [matTooltip]="'CHAT.MENTIONED_YOU' | translate"
                  >&#64;</span
                >
                <!-- muted : point discret au lieu du compteur (exclu du badge global) -->
                <div
                  *ngIf="(conversation.unread_count ?? 0) > 0 && !conversation.is_muted"
                  class="mt-4 unread-message-count accent"
                >
                  {{ conversation.unread_count }}
                </div>
                <div
                  *ngIf="(conversation.unread_count ?? 0) > 0 && conversation.is_muted"
                  class="mt-4 chat-muted-unread-dot"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
    <!-- / CHATS LIST-->

    <!-- NO RESULTS MESSAGE -->
    <div *ngIf="filteredConversations().length === 0" class="no-results-message">
      {{ 'CHAT.NO_RESULTS' | translate }}
    </div>
    <!-- NO RESULTS MESSAGE-->
  </div>
  <!-- / CHATS CONTENT -->
</div>
<!-- / SIDENAV CONTENT -->
